import { Link, NavLink } from "react-router-dom";
import { UserCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Wordmark } from "@/components/brand/Wordmark";
import { WhistllLogo } from "@/components/brand/WhistllLogo";
import { ThemeToggle } from "./ThemeToggle";

// "Find a run" is intentionally hidden from public nav until launch
// day. Pre-launch, an empty court browser turns prospective venues
// off ("nobody's using this yet"); we'd rather they land on /venues
// and get the partner pitch first. The page itself still exists at
// /courts for direct links + admin/QA.
const navItems = [
  { to: "/", label: "Home" },
  { to: "/venues", label: "For venues" },
];

export function Header() {
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/70 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-6">
        <Link
          to="/"
          className="flex items-center gap-2.5 transition-opacity hover:opacity-85"
        >
          <WhistllLogo size={26} />
          <Wordmark size="text-2xl" />
        </Link>

        <div className="flex items-center gap-1">
          <nav className="flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  cn(
                    "relative px-3 py-2 text-sm font-medium transition-colors",
                    "after:absolute after:bottom-1 after:left-3 after:right-3",
                    "after:h-[2px] after:rounded-full after:transition-all",
                    isActive
                      ? "text-foreground after:bg-volt"
                      : "text-muted-foreground after:bg-transparent hover:text-foreground hover:after:bg-volt/40"
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <ThemeToggle className="ml-1" />
          <Link
            to="/login"
            aria-label="Sign in"
            title="Sign in (for venue partners & staff)"
            className="ml-1 inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
          >
            <UserCircle2 className="h-5 w-5" aria-hidden />
          </Link>
        </div>
      </div>
    </header>
  );
}
